import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Lock, PlayCircle } from "lucide-react";

// Tagesleiste: offene Tage anklickbar, gesperrte Tage grau, Wrap-up ab Tag 5.
export const ChallengeDayNav = ({ day, state }) => {
  const navigate = useNavigate();
  if (!state) return null;
  const total = state.total_days || 5;
  const done = new Set(state.completed_days || []);
  const nextLabel = state.next_unlock_at
    ? new Date(state.next_unlock_at).toLocaleString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
    : null;
  return (
    <nav className="mt-6 space-y-3" data-testid="challenge-day-nav">
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: total }, (_, i) => i + 1).map((d) => {
          const open = d <= (state.days_unlocked || 0);
          return (
            <button key={d} type="button" disabled={!open} onClick={() => navigate(`/challenge/tag/${d}`)} data-testid={`challenge-day-nav-${d}`}
              className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold border transition-colors ${d === day ? "bg-[#F3651D] text-white border-[#F3651D]" : open ? "bg-white text-slate-800 border-slate-300 hover:border-[#F3651D]" : "bg-slate-100 text-slate-400 border-slate-200 cursor-not-allowed"}`}>
              {done.has(d) ? <CheckCircle2 className="w-4 h-4" /> : open ? null : <Lock className="w-3.5 h-3.5" />} Tag {d}
            </button>
          );
        })}
        {state.wrapup_available && (
          <button type="button" onClick={() => navigate("/challenge/wrapup")} data-testid="challenge-day-nav-wrapup"
            className="inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-semibold border bg-[#0F172A] text-white border-[#0F172A] hover:opacity-90">
            <PlayCircle className="w-4 h-4" /> Wrap-up
          </button>
        )}
      </div>
      {nextLabel && <p className="text-xs text-slate-500" data-testid="challenge-day-nav-next">Nächster Tag öffnet: {nextLabel}</p>}
    </nav>
  );
};

export default ChallengeDayNav;
